<template>
  <div id="affiliate" :style="style()" ref="app">
    <template v-if="!showAffiliateDetail">
    <div class="cc-leaderboard-header row">
        <div class="view-full-leaderboard col-12 col-sm-4" :style="{backgroundColor:settings.main_color}">
            <a href="" target="_blank">View Full LeaderBoard</a>
        </div>
        <div class="leaderboards-list col-sm-4 col-12" :style="{backgroundColor:settings.second_color}">
            <select v-model="currentEvent" :style="style()">
                <option v-for="event in settings.events" :key="event.id" :value="event.id">{{ event.name }}</option>
            </select>
            <material-icons icon="arrow_drop_down"/>
        </div>
        <div class="leaderboard-groups col-sm-4 col-12" :style="{backgroundColor:settings.second_color}">
            <select v-model="currentGroup" :style="style()">
                <option v-for="(event, index) in settings.groups" :key="index" :value="index">{{ event }}</option>
            </select>
            <material-icons icon="arrow_drop_down"/>
        </div>
    </div>
    <div class="results-wrapper">
      <ul class="cc-leaderboard-results-table">
        <li>
          <ul class="row result-header">
            <li :class="{'col-4':1,active:orderBy=='Affiliate'}">
              <span @click="()=>{if(orderBy=='Affiliate'){orderASC = !orderASC};orderBy='Affiliate';}">
                <material-icons class="sort-order" v-if="orderBy=='Affiliate'" :icon="orderASC?'arrow_upward':'arrow_downward'"/>
                Affiliate
              </span>
            </li>
            <li :class="{'col':1,active:orderBy=='Participants'}" style="text-align:center">
              <span @click="()=>{if(orderBy=='Participants'){orderASC = !orderASC};orderBy='Participants';}">
                <material-icons class="sort-order" v-if="orderBy=='Participants'" :icon="orderASC?'arrow_upward':'arrow_downward'"/>
                Participants
              </span>
            </li>
          </ul>
        </li>
        <li v-for="(result, index) in getData()" :key="index">
          <ul class="row cc-leaderboard-result">
            <li class="col-4">
              <div class="row">
                <div class="col">
                  <span class="name" @click="showAffiliateDetail=true;leaderboardResults=result.Athletes;leaderboardResultsWorkouts=result.workouts"><strong>{{result.Affiliate}}</strong></span>
                </div>
              </div>
            </li>
            <li class="col" style="text-align:center">{{result.Participants}}</li>
          </ul>
        </li>
      </ul>
    </div>
    </template>
    <cc-results v-if="showAffiliateDetail" :results="leaderboardResults" :workouts="leaderboardResultsWorkouts"></cc-results>
    <a href="#" v-if="showAffiliateDetail" @click="showAffiliateDetail=false">Back</a>
  </div>
</template>

<script>
import MaterialIcons from './components/Icon.vue'
import Results from './components/Results.vue'
export default {
  name: 'Affiliate',
  data () {
    return {
      settings: {},
      keyword: '',
      currentEvent: null,
      currentGroup: null,
      results: [],
      orderBy: 'place',
      orderASC: true,
      numberWorkoutsToShow: 2,
      startWorkouts: 0,
      endWorkouts: 3,
      appWidth: 0,
      showFlag: true,
      leaderboardResults: null,
      leaderboardResultsWorkouts: null,
      showAffiliateDetail: false
    }
  },
  components: { MaterialIcons, 'cc-results': Results },
  created () {
    this.settings = cc_leaderboard_settings;
    this.currentEvent = this.settings.events[0].id;
    this.currentGroup = Object.keys(this.settings.groups)[0];
    this.results = cc_leaderboard_settings.results.Athletes;
    this.endWorkouts = this.numberWorkoutsToShow;
  },
  mounted() {
    this.appWidth = this.$refs.app.clientWidth;
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.appWidth = this.$refs.app.clientWidth;
      });
    })
  },
  methods: {
    style () {
      var style = {};
      if(this.settings.fonts){
        style.fontFamily = this.settings.fonts.split('|')[0];
      }
      return style;
    },
    getData () {
      var results = JSON.parse(JSON.stringify(this.results));
      var affiliates = [];
      results.forEach(element => {
        let affiliate = element.Affiliate.trim();
        if(affiliates.find(e => {return e.Affiliate == affiliate}) === undefined){
          affiliates.push({
            Affiliate: affiliate,
            Participants: 1,
            Athletes: [element],
            workouts: this.settings.results.Workouts
          })
        }else{
          affiliates.find(e => {return e.Affiliate == affiliate}).Participants ++;
          affiliates.find(e => {return e.Affiliate == affiliate}).Athletes.push(element);
        }
      });
      if(this.orderBy == 'Affiliate'){
        affiliates.sort((a,b) => {
          if(this.orderASC){
            return ((a.Affiliate < b.Affiliate) ? -1 : ((a.Affiliate > b.Affiliate) ? 1 : 0));
          }else{
            return ((a.Affiliate > b.Affiliate) ? -1 : ((a.Affiliate < b.Affiliate) ? 1 : 0));
          }
        })
      }
      if(this.orderBy == 'Participants'){
        affiliates.sort((a,b) => {
          if(this.orderASC){
            return ((a.Participants < b.Participants) ? -1 : ((a.Participants > b.Participants) ? 1 : 0));
          }else{
            return ((a.Participants > b.Participants) ? -1 : ((a.Participants < b.Participants) ? 1 : 0));
          }
        })
      }
      return affiliates.slice(0, this.settings.top_x);
    }
  },
  watch: {
    currentEvent (val){
      var api_url = 'https://competitioncorner.net/events/'+ val +'/scoring-groups/json';
      jQuery.ajax({
          url: cc_leaderboard_settings.ajax_url,
          type: 'POST',
          data: {
              action: 'event_api_action',
              api_url: api_url
          },
          success: (res) => {
            this.settings.groups = res.data;
            this.currentGroup = Object.keys(this.settings.groups)[0];
          }
      });
    },
    currentGroup (val) {
      var api_url = 'https://competitioncorner.net/events/' + this.currentEvent + '/results/scoring-group/' + val + '/json';
      jQuery.ajax({
          url: cc_leaderboard_settings.ajax_url,
          type: 'POST',
          data: {
              action: 'event_api_action',
              api_url: api_url
          },
          success: (res) => {
            this.settings.results = res.data;
            this.results = res.data.Athletes;
            this.startWorkouts = 0;
          }
      });
    },
    orderBy (){
      this.orderASC = true;
    },
    appWidth (val){
      if(val < 767){
        this.numberWorkoutsToShow = 1;
        this.showFlag = false;
      }else if(val >= 768 && val < 992){
        this.numberWorkoutsToShow = 2;
        this.showFlag = false;
      }else if(val >= 992){
        this.numberWorkoutsToShow = 3;
        this.showFlag = true;
      }
      this.startWorkouts = 0;
      this.endWorkouts = this.numberWorkoutsToShow;
    },
    startWorkouts (val){
      this.endWorkouts = val + this.numberWorkoutsToShow;
    }
  }
}
</script>

<style>
#affiliate {
  max-width: 1140px;
  margin: 0 auto;
}
</style>
<style lang="scss" scoped>
  @import url('//fonts.googleapis.com/icon?family=Material+Icons');
  @import 'assets/grid.scss';
  .sort-order{
    font-size: 13px;
  }
  input.athlete-search{
    border: 1px solid #e0e0e0;
    padding: 0 30px;
    font-size: 13px;
    border-radius: 0;
    line-height: 33px;
    &::-webkit-input-placeholder{
      color: #e3e3e3;
    }
    &::-moz-placeholder{
      color: #e3e3e3;
    }
    &:-ms-input-placeholder{
      color: #e3e3e3;
    }
  }
  .search-icon{
    position: absolute;
    font-size: 17px;
    line-height: 35px;
    left: 9px;
  }
  .view-full-leaderboard,
  .leaderboards-list,
  .leaderboard-groups{
      color: #fff;
      line-height: 27px;
  }
  .cc-leaderboard-header{
      display: flex;
  }
  .cc-leaderboard-header select{
    background: transparent;
    border: none;
  }
  .arrow-up.icon {
    color: #000;
    position: absolute;
    margin-left: 10px;
    margin-top: 3px;
    width: 1px;
    height: 16px;
    background-color: currentColor;
  }
  .arrow-up.icon:before {
    content: '';
    position: absolute;
    left: -5px;
    top: 1px;
    width: 10px;
    height: 10px;
    border-top: solid 1px currentColor;
    border-right: solid 1px currentColor;
    -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
  }
  ul.row{
    margin: 0;
    padding: 0;
    list-style: none;
  }
  ul.result-header{
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    li{
      border-top: 1px solid #e0e0e0;
      border-left: 1px solid #e0e0e0;
      padding: 10px 12px;
      span{
        font-weight: bold;
      }
      &.active{

      }
    }
  }
  ul.result-header-second{
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    >li{
      border-left: 1px solid #e0e0e0;
      font-size: 12px;
      color: #9E9E9E;
      padding: 5px 12px;
    }
  }
  li.row-odd{
    background: #fcfcfc;
  }
  ul.cc-leaderboard-result{
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    >li{
      border-left: 1px solid #e0e0e0;
      padding: 5px 12px;
    }
    span.name{
      text-transform: uppercase;
      span.affiliate{
        display: block;
        color: #757575;
        font-size: 11px;
        text-transform: unset;
      }
    }
  }
  .results-wrapper{
    overflow: auto;
    position: relative;
    .carousel-controls{
      position: absolute;
      top: 50%;
      width: 100%;
      button{
        background: rgba($color: #000000, $alpha: 0.5);
        border: 1px solid #e3e3e3;
        width: 40px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        padding: 0;
        opacity: 0.5;
        &:hover{
          opacity: 1;
        }
        i{
          display: block;
          font-size: 30px;
        }
        &.next{
          position: absolute;
          right: 0;
        }
      }
    }
  }
  ul.cc-leaderboard-results-table{
    margin: 0;
    padding: 0;
    list-style: none;
    >li{
      margin: 0;
      padding: 0;
    }
  }
  .cc-leaderboard-header{
    select{
      height: 40px;
      line-height: 40px;
      color: #fff;
      width: 100%;
      -webkit-appearance: none;
      -moz-appearance: none;
      padding: 0 12px;
      position: relative;
      z-index: 10;
      &::-ms-expand{
        display: none;
      }
    }
    .view-full-leaderboard{
      a{
        padding-left: 12px;
        display: block;
        line-height: 40px;
        color: #fff;
      }
    }
  }
  .leaderboards-list{
    border-right: 1px solid #e0e0e0;
  }
  .leaderboard-groups,
  .leaderboards-list{
    position: relative;
    .material-icons{
      position: absolute;
      right: 10px;
      top: 7px;
      z-index: 1;
    }
  }
</style>